/* eslint-disable react/no-array-index-key */
import React from 'react';
import ContentLoader from 'react-content-loader';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const fakeReceptions = Array(8).fill(0);
/**
 * Affiche le composant d'information sur les produits du colis dans le drawer
 * de la section Expéditions
 */
const ReceptionsTableLoader = () => (
  <TableBody>
    {fakeReceptions.map((reception, index) => (
      <TableRow key={index}>
        <TableCell align="left">
          <ContentLoader
            height={5}
            width={170}
            speed={2}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="24" y="-8" rx="0" ry="0" width="135" height="29" />
          </ContentLoader>
        </TableCell>
        <TableCell align="left">
          <ContentLoader
            height={5}
            width={170}
            speed={2}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="24" y="-8" rx="0" ry="0" width="135" height="29" />
          </ContentLoader>
        </TableCell>
        <TableCell align="left">
          <ContentLoader
            height={5}
            width={170}
            speed={2}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="24" y="-8" rx="0" ry="0" width="135" height="29" />
          </ContentLoader>
        </TableCell>
        <TableCell align="left">
          <ContentLoader
            height={5}
            width={170}
            speed={2}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="24" y="-8" rx="0" ry="0" width="135" height="29" />
          </ContentLoader>
        </TableCell>
        <TableCell align="left">
          <ContentLoader
            height={5}
            width={170}
            speed={2}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="24" y="-8" rx="0" ry="0" width="135" height="29" />
          </ContentLoader>
        </TableCell>
        <TableCell align="left">
          <ContentLoader
            height={5}
            width={170}
            speed={2}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="24" y="-8" rx="0" ry="0" width="135" height="29" />
          </ContentLoader>
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
);

export default ReceptionsTableLoader;
